import {MutableRefObject, useCallback, useMemo} from "react";

export interface IFormData {
    firstDigit: number | null;
    secondDigit: number | null;
    thirdDigit: number | null;
    fourthDigit: number | null;
}

export const digitFields: (keyof IFormData)[] = ["firstDigit", "secondDigit", "thirdDigit", "fourthDigit"];

type InputRefsArray = MutableRefObject<(HTMLInputElement | null)[]>;

export const useDigitInputNavigation = (inputRefs: InputRefsArray) => {
    const moveToNextField = useCallback(
        (currentField: keyof IFormData) => {
            const currentIndex = digitFields.indexOf(currentField);
            const nextInput = inputRefs.current[currentIndex + 1];
            nextInput?.focus();
        },
        [inputRefs]
    );

    const moveToPreviousField = useCallback(
        (currentField: keyof IFormData) => {
            const currentIndex = digitFields.indexOf(currentField);
            const previousInput = inputRefs.current[currentIndex - 1];
            previousInput?.focus();
        },
        [inputRefs]
    );

    const focusFieldByIndex = useCallback(
        (index: number) => {
            const input = inputRefs.current[index];
            input?.focus();
        },
        [inputRefs]
    );

    return useMemo(
        () => ({
            moveToNextField,
            moveToPreviousField,
            focusFieldByIndex
        }),
        [moveToNextField, moveToPreviousField, focusFieldByIndex]
    );
};
import {MutableRefObject, useCallback, useMemo} from "react";

export interface IFormData {
    firstDigit: number | null;
    secondDigit: number | null;
    thirdDigit: number | null;
    fourthDigit: number | null;
}

export const digitFields: (keyof IFormData)[] = ["firstDigit", "secondDigit", "thirdDigit", "fourthDigit"];

type InputRefsArray = MutableRefObject<(HTMLInputElement | null)[]>;

export const useDigitInputNavigation = (inputRefs: InputRefsArray) => {
    const moveToNextField = useCallback(
        (currentField: keyof IFormData) => {
            const currentIndex = digitFields.indexOf(currentField);
            const nextInput = inputRefs.current[currentIndex + 1];
            nextInput?.focus();
        },
        [inputRefs]
    );

    const moveToPreviousField = useCallback(
        (currentField: keyof IFormData) => {
            const currentIndex = digitFields.indexOf(currentField);
            const previousInput = inputRefs.current[currentIndex - 1];
            previousInput?.focus();
        },
        [inputRefs]
    );

    const focusFieldByIndex = useCallback(
        (index: number) => {
            const input = inputRefs.current[index];
            input?.focus();
        },
        [inputRefs]
    );

    return useMemo(
        () => ({
            moveToNextField,
            moveToPreviousField,
            focusFieldByIndex
        }),
        [moveToNextField, moveToPreviousField, focusFieldByIndex]
    );
};
